import { GlobalController } from 'src/shared/global/GlobalController'
import Carrier from './Carrier'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'carrier',
    component: Carrier,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
